module.exports = __webpack_public_path__ + "img/ic_topic_food-active.5c0b66ea.svg";